export default __webpack_public_path__ + "static/adventure-0845630012e86d3c0e4da7f0bf766837.svg";